<template>
	<div id="app">
		<Header class="box__nav" @change="change" />
		<div class="box__container">
			<Aside class="box__aside" v-if="!page" />
			<router-view class="box__content" />
		</div>
	</div>
</template>

<script>
import "@/assets/css/reset.css";
import "@/assets/css/common.css";
import Header from "@/components/Header";
import Aside from "@/components/Aside";
export default {
	name: "App",
	components: {
		Header,
		Aside
	},
	data() {
		return {
			page: false
		};
	},
	mounted() {
		this.page =
			this.$route.path == "/connect" || this.$route.path == "/about";
	},
	methods: {
		change(value) {
			this.page = value;
		}
	}
};
</script>

<style lang="less">
#app {
	width: 100%;
	height: 100%;
}
.box__nav {
	width: 100%;
	height: 70px;
	box-sizing: border-box;
}
.box__container {
	width: 100%;
	display: flex;
	height: calc(100% - 70px);

	.editor__box {
		height: 100%;
		.vue-run-sfc-main {
			height: calc(100% - 44px - 58px);
			.vue-run-sfc-editor,
			.vue-run-sfc-preview {
				height: 100%;
				box-sizing: border-box;
			}
			.vue-run-sfc-preview {
				iframe {
					height: 100% !important;
				}
			}
		}
		.CodeMirror-sizer,
		.CodeMirror-sizer > div,
		.CodeMirror-lines,
		.CodeMirror-lines > div,
		.CodeMirror-code {
			height: 100%;
		}
		.vue-run-sfc-preview {
			padding: 10px;
		}
		.power-by-text {
			display: none;
		}
	}
}
.box__aside {
	background: rgb(0, 100, 255);
	border-right: solid 1px #e6e6e6;
}
.box__content {
	flex: 1;
	position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue